module.exports = __webpack_public_path__ + "img/earth.3ba24573.png";